<div class="col-lg-12 quienes-somos-blq6 mb-lg-flex-dir-col">
               
    <div class="col-lg-4 col-md-12 col-sm-12 col-12 px-lg-3 px-md-0" data-aos="fade-right" data-aos-duration="1500">
        <p class="text-uppercase" [innerHTML]="twoColAreaNoButtonItems.twoColArea_preTitle"></p>
        <h1 class="fw-bolder" [innerHTML]="twoColAreaNoButtonItems.twoColArea_title"></h1>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 col-12 col-sm-12 col-md-12 col-lg-4" data-aos="fade-right" data-aos-duration="1500">
        <p class="mt-lg-5 mt-md-0 px-lg-5 px-md-0" [innerHTML]="twoColAreaNoButtonItems.twoColArea_mainText"></p>
       
    </div>
</div>
